// src/utils/tex.js
// Consente di scrivere LaTeX come in un editor: tex`\frac{a}{b}`
// String.raw mantiene i backslash nelle template literals
export const tex = String.raw;
